import RequestBase from '../Resources/RequestBase';

export default class PostcodeSearchRequest extends RequestBase {
    constructor(success) {
        super();
        this._url = '/Addresses?postcode={postcode}';
        this.method = 'GET';
        this.test = true;
        this.success = success;
        this.error = 'Wrong parameters';
        this.data = {data: [
            {
                'Line1': 'Westbourne Studio',
                'Line2': '12 Holloway Road',
                'Town': 'London',
                'Postcode': 'W105JJ'
            },
            {
                'Line1': 'Flat 456',
                'Line2': '12 Holloway Road',
                'Town': 'London',
                'Postcode': 'W105JJ'
            }
        ]};
    }
}



// WEBPACK FOOTER //
// ./src/TestResources/Addresses.js